module.exports = {"130623001":"城区社区管理办公室街道","130623100":"涞水镇","130623101":"永阳镇","130623102":"义安镇","130623103":"石亭镇","130623104":"赵各庄镇","130623105":"九龙镇","130623106":"三坡镇","130623107":"一渡镇","130623108":"明义镇","130623109":"王村镇","130623110":"娄村镇","130623202":"东文山乡","130623205":"其中口乡","130623206":"龙门乡","130623207":"胡家庄乡","130623400":"涞水县经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130623.json
// module id = 157
// module chunks = 0